import { useStorage } from '@vueuse/core'
import { FormRendererModelType } from '@/types/form-renderer'

const STORAGE_KEY = 'Cdr_Forms'

const FormsStorage = useStorage<FormRendererModelType>(STORAGE_KEY, {})

export default FormsStorage
